export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v2-15a0e970c7dcfe2690b9084de431ec6f.png";